import { CategoryScale, Chart as ChartJS, Legend, LineController, LineElement, LinearScale, PointElement, Title, Tooltip, scales } from "chart.js";
import React, { useEffect, useState, useMemo } from "react";
import { Line } from 'react-chartjs-2';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { to } from "react-spring";

ChartJS.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend);

const ChartBox = styled.div`
    width: 100%;
    height: 250px;
    padding: 0rem;
    display: flex;
    align-items: top;
    justify-content: center;
`;

function DayMonthSaleChart({dateData,saleData, lastYearDateData, lastYearSaleData,crdInfo,mode}) {
    
    const {t} = useTranslation();

    const currencySymbol = crdInfo && crdInfo.natnCd === "KR" ? "₩" : crdInfo && crdInfo.natnCd === "JP" ? "¥" : "$";
    // x축 라벨: 월(MM)만 표시
    //const labels = dateData.map((data) => data.slice(5, 7) + "월");
    const labels = dateData.map((data) => data.slice(5, 10));

    const datasets = [
        {
            label: `${t('dashboardPage.sale')} ${currencySymbol}`,
            data: saleData,
            fill: false,
            borderColor: 'rgba(75, 192, 192, 1)',
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            tension: 0.1,
            pointRadius: 6,
        },
    ];

    // 월별 모드이고 작년 데이터가 있을 때만 추가
    if (mode === 'month' && lastYearSaleData && lastYearSaleData.length > 0) {
        datasets.push({
            label: `${t('dashboardPage.sale')} (${t('dashboardPage.lastYear')}) ${currencySymbol}`,
            data: lastYearSaleData,
            fill: false,
            borderColor: 'rgba(255, 159, 64, 1)',
            backgroundColor: 'rgba(255, 159, 64, 0.2)',
            //borderDash: [5, 5], // 점선으로 구분
            tension: 0.1,
            pointRadius: 6,
        });
    }

    const chartData = {
        
        labels,
        datasets,
    }
    
    const options = {
        maintainAspectRatio: false,
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 10
                    },
                }
            }
        },
        plugins: {
            legend: {
                display: mode === 'month' && lastYearSaleData && lastYearSaleData.length > 0,
                position: 'bottom',
                labels: {
                    // 1. 박스(컬러 아이콘) 크기 조절
                    boxWidth: 12,    
                    boxHeight: 12,   
                    // 2. 폰트 크기 조절
                    font: { size: 11 },
                    // 3. 아이콘과 텍스트 사이의 간격 (필요시)
                    padding: 10,
                    generateLabels: (chart) => {
                        const data = chart.data;
                        return data.datasets.map((dataset, i) => ({
                            text: dataset.label.replace(currencySymbol, '').trim(),
                            fillStyle: dataset.backgroundColor,
                            strokeStyle: dataset.borderColor,
                            lineWidth: 2,
                            hidden: !chart.isDatasetVisible(i),
                            datasetIndex: i
                        }));
                    }
                }
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const label = context.dataset.label || '';
                        const value = context.parsed.y !== null ? context.parsed.y.toLocaleString() : '0';
                        return `${label}: ${value}`;
                    },
                    title: (tooltipItems) => {
                        const idx = tooltipItems[0].dataIndex;
                        const dsIdx = tooltipItems[0].datasetIndex;
    
                        if (mode === 'month') {
                            const targetDateArr = dsIdx === 0 ? dateData : lastYearDateData;
                            if (targetDateArr && targetDateArr[idx]) {
                                const [year, month] = targetDateArr[idx].split('-');
                                return `${year}${t('dashboardPage.year')} ${month}${t('dashboardPage.month')}`;
                            }
                        }
                        // 일별 모드
                        return dateData[idx] ?? tooltipItems[0].label;
                    }
                }
            }
        },
    };
    

    return (
        <ChartBox>
            {chartData && <Line options={options} data={chartData} width={"800px"} height={"320px"} />}
        </ChartBox>
    )
}
export default DayMonthSaleChart;

export const MemorizedDayMonthSaleChart = React.memo(DayMonthSaleChart);